import { AiOutlineGithub, AiOutlineLink } from "react-icons/ai";
import cryptoNex from "../assets/cryptoNex.png"
import Nexventory from "../assets/Nexventory.png"
import { motion } from "framer-motion";
import hospital from "../assets/Hospital Management.png"
import pos from "../assets/g2.png"
const projects = [
  {
    title: "CryptoNex",
    image: cryptoNex,
    desc: "CryptoNex offers a user-friendly interface for accessing real-time data and detailed information about various cryptocurrencies",
    tech: ["React", "TailwindCss"],
    demo: "https://crypto-nex.vercel.app/",
    code: "https://github.com/RehanShafqat/CryptoNex",
  },
  {
    title: "Full Stack POS System",
    image: pos,
    desc: "Metro POS System is a software designed for retail stores and supermarkets.It provides user roles with specific access and functionality, including Super Admin, Branch Manager, Data Entry Operator, and Cashier.",
    tech: ["Java", "JavaFX", "PostgreSQL"],
    demo: null,
    code: "https://github.com/Gate-Solutions/MetroPOS",
  },
  {
    title: "NexVentory",
    image: Nexventory,
    desc: "NexVentory is a full Stack web app made for mantainence of inventory.It includes different views for Admin, Manager and Customers with real time graph analysis on admin dashboard ",
    tech: ["React", "TailwindCss", "Redux Toolkit", "MySql", "Express"],
    demo: null,
    code: "https://github.com/RehanShafqat/Inventory-Management",
  },
  {
    title: "Hospital Management System",
    image: hospital,
    desc: "A Hospital Management System that is comprehensive and integrated software solution designed to manage all aspects of a hospital's operations. It includes patient , doctor and admin entities",
    tech: ["React", "Express", "MongoDB"],
    demo: null,
    code: "https://github.com/RehanShafqat/Hospital-Managamenet-System",
  },

];

const Projects = () => {
  const itemVars = {
    initial: { opacity: 0, y: 100 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  return (
    <section id="projects" className="projects container">
      <div className="section__heading">
        <h3 className="section__heading--sub">- Projects</h3>
        <h2 className="section__heading--main">Recently completed projects</h2>
      </div>

      <div className="projects__list">
        {projects.map((project, idx) => {
          const { title, image, desc, demo, code, tech } = project;
          return (
            <motion.div
              variants={itemVars}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className={`projects__item ${idx % 2 ? "projects__item--rev" : ""
                }`}
              key={idx}
            >
              <img
                src={image}
                alt="project"
                className="projects__img"
                onClick={() => demo && window.open(demo, "blank")}
              />
              <div className="projects__info">
                <h2 className="projects__title">{title}</h2>
                <p className="projects__desc">{desc}</p>
                <div className="projects__tech">
                  {tech.map((el, idx) => {
                    return (
                      <div key={idx} className="projects__tech--item">
                        {el}
                      </div>
                    );
                  })}
                </div>

                <div className="projects__links">
                  <a
                    href={code}
                    target="blank"
                    className="projects__links--item"
                  >
                    <p>Code</p>
                    <AiOutlineGithub />
                  </a>
                  {
                    demo && (
                      <a
                        href={demo}
                        target="blank"
                        className="projects__links--item"
                      >
                        <p>Live Demo</p>
                        <AiOutlineLink />
                      </a>
                    )
                  }
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
